import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=212ff421&scoped=true&"
import script from "./categorias.vue?vue&type=script&lang=ts&"
export * from "./categorias.vue?vue&type=script&lang=ts&"
import style0 from "./categorias.vue?vue&type=style&index=0&id=212ff421&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ff421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
